import React from 'react';
import { 
  Store, Mail, Phone, MapPin, 
  CheckCircle, XCircle, Search, FileText, ExternalLink
} from 'lucide-react';
import { Link } from 'react-router-dom';

// --- MOCK DATA FOR PENDING SELLERS ---
const PENDING_APPLICATIONS = [
  { id: 'APP-1029', name: 'Plant Oasis Hub', owner: 'Suresh Kumar', email: 'hello@plantoasis.in', phone: '+91 88990 11223', location: 'Chennai, TN', reqDate: '2 hours ago', docs: ['GST Certificate', 'Trade License', 'Owner ID'] },
  { id: 'APP-1028', name: 'Desert Flora', owner: 'Anita Roy', email: 'contact@desertflora.com', phone: '+91 77889 22334', location: 'Jaipur, RJ', reqDate: 'Yesterday, 2:30 PM', docs: ['GST Certificate', 'Pan Card'] },
  { id: 'APP-1027', name: 'Himalayan Seeds', owner: 'Tenzin Phuntsok', email: 'sales@himalayanseeds.com', phone: '+91 99887 66554', location: 'Shimla, HP', reqDate: '2 Days ago', docs: ['FSSAI License', 'GST Certificate', 'Business Reg'] },
];

const PendingSellers = () => {
  return (
    <div className="animate__animated animate__fadeIn">
      {/* Header */}
      <div className="admin-page-header">
        <div>
          <div className="d-flex align-items-center gap-3">
            <Link to="/admin/dashboard" className="btn btn-sm btn-light shadow-none text-muted border-0 p-1 rounded-circle d-flex align-items-center justify-content-center" style={{ width: 32, height: 32 }}>
               <i className="ph ph-arrow-left fs-5"></i>
            </Link>
            <h1 className="admin-page-title mb-0">Pending Approvals</h1>
          </div>
          <p className="admin-page-subtitle mt-2">Review applications from new sellers wishing to join the platform.</p>
        </div>
      </div>

      <div className="row g-4 mb-4">
        {/* Statistics/Filters Side */}
        <div className="col-12 col-xl-4">
          <div className="admin-card mb-4" style={{ backgroundColor: '#fffbeb', border: '1px solid #fde68a' }}>
            <div className="admin-card-body p-4">
              <h4 className="fw-bold mb-1" style={{ color: '#92400e', fontSize: '2rem' }}>{PENDING_APPLICATIONS.length}</h4>
              <p className="fw-medium mb-0" style={{ color: '#b45309' }}>Applications awaiting your review</p>
            </div>
          </div>
          
          <div className="admin-card">
            <div className="admin-card-header">
              <h6 className="fw-bold mb-0 text-dark">Quick Filters</h6>
            </div>
            <div className="admin-card-body p-3">
              <div className="input-group mb-3" style={{ borderRadius: '8px', overflow: 'hidden', border: '1px solid #e2e8f0' }}>
                <span className="input-group-text bg-white border-0 text-muted px-3">
                  <Search size={16} />
                </span>
                <input 
                  type="text" 
                  className="form-control border-0 shadow-none bg-white" 
                  placeholder="Search by ID or name..."
                  style={{ fontSize: '0.85rem' }}
                />
              </div>
              <div className="mb-3">
                <label className="form-label text-muted fw-bold" style={{ fontSize: '0.75rem', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Sort By</label>
                <select className="form-select shadow-none border-slate-200" style={{ fontSize: '0.875rem', borderRadius: '8px' }}>
                  <option>Newest First</option>
                  <option>Oldest First</option>
                  <option>Alphabetical</option>
                </select>
              </div>
            </div>
          </div>
        </div>

        {/* Applications List */}
        <div className="col-12 col-xl-8">
          <div className="d-flex flex-column gap-4">
            {PENDING_APPLICATIONS.map((app) => (
              <div key={app.id} className="admin-card">
                <div className="admin-card-header bg-light border-bottom px-4 py-3 d-flex justify-content-between align-items-center">
                  <div className="d-flex align-items-center gap-2">
                    <span className="admin-badge warning">Pending</span>
                    <span className="text-secondary fw-bold" style={{ fontSize: '0.8rem' }}>{app.id}</span>
                  </div>
                  <span className="text-muted fw-medium" style={{ fontSize: '0.8rem' }}>Applied {app.reqDate}</span>
                </div>
                
                <div className="admin-card-body p-4">
                  <div className="row g-4">
                    <div className="col-md-7">
                      <div className="d-flex align-items-start gap-3 mb-3">
                        <div className="stat-icon-wrapper orange" style={{ width: 48, height: 48, borderRadius: '12px' }}>
                          <Store size={24} />
                        </div>
                        <div>
                          <h5 className="fw-bold text-dark mb-1">{app.name}</h5>
                          <p className="text-muted fw-medium mb-0" style={{ fontSize: '0.85rem' }}>Proprietor: <span className="text-dark">{app.owner}</span></p>
                        </div>
                      </div>
                      
                      <div className="d-flex flex-column gap-2 text-secondary px-3 py-2 bg-light rounded-3" style={{ fontSize: '0.85rem' }}>
                        <span className="d-flex align-items-center gap-2"><Mail size={14} className="text-muted"/> {app.email}</span>
                        <span className="d-flex align-items-center gap-2"><Phone size={14} className="text-muted"/> {app.phone}</span>
                        <span className="d-flex align-items-center gap-2"><MapPin size={14} className="text-muted"/> {app.location}</span>
                      </div>
                    </div>
                    
                    <div className="col-md-5 border-start border-slate-200 ps-md-4">
                      <h6 className="fw-bold text-dark mb-3" style={{ fontSize: '0.9rem' }}>Attached Documents</h6>
                      <ul className="list-unstyled d-flex flex-column gap-2 mb-0">
                        {app.docs.map((doc, idx) => (
                           <li key={idx} className="d-flex align-items-center justify-content-between border border-slate-200 rounded p-2 bg-white">
                             <span className="d-flex align-items-center gap-2 text-dark fw-medium" style={{ fontSize: '0.8rem' }}>
                               <FileText size={14} className="text-primary"/> {doc}
                             </span>
                             <button className="btn btn-sm p-0 text-muted shadow-none">
                               <ExternalLink size={14} />
                             </button>
                           </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
                
                <div className="admin-card-body p-3 px-4 bg-light border-top d-flex justify-content-end gap-2">
                  <button className="admin-btn admin-btn-outline d-flex align-items-center gap-2 text-danger" style={{ borderColor: '#f87171' }}>
                    <XCircle size={16} /> Reject
                  </button>
                  <button className="admin-btn admin-btn-primary d-flex align-items-center gap-2" style={{ backgroundColor: '#10b981', borderColor: '#10b981' }}>
                    <CheckCircle size={16} /> Approve Application
                  </button>
                </div>
              </div>
            ))}
            
            {PENDING_APPLICATIONS.length === 0 && (
              <div className="admin-card p-5 text-center">
                <Store size={48} className="text-muted mb-3 mx-auto" opacity={0.5}/>
                <h5 className="fw-bold text-dark">No Pending Applications</h5>
                <p className="text-secondary">You have caught up with all seller approvals!</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PendingSellers;
